import { API } from "./baseService";
import APP_CONST from "../../core/shared/constants";

export const tmfStructureDataService = () => {
  const contextPath = APP_CONST.API.ZONE_LIST;
  return API.get(contextPath, { type: "document" });
};

export const getMileStoneCount = () => {
  const contextPath = APP_CONST.API.MILESTONES_COUNT;
  return API.get(contextPath, { type: "document" });
};

export const getFooter = () => {
  const contextPath = APP_CONST.API.VIDEOC_CLIENT;
  return API.get(contextPath, { type: "document" });
};
export const downloadSignatureDetailsWithSAS = (data) => {
  return API.get(`document/getshareddocumentsastokenasync?SharingBinderId=${data.bindersId}&&FileName=${data.fileName}&&FriendlyFileName=${data.friendlyfilename}&&isToGetSignedFile=${data.isToGetSignedFile}&&isfrometmfbinder=true`);
};

export const doGetDocumentGuid = () => {
  const contextPath = APP_CONST.API.DOCUMENT_GUID;
  return API.get(contextPath, { type: "document" });
};

export const doGetDocHistory = (payload) => {
  const { documentid, lastModifiedOn, documentversionguid } = payload;
  const contextPath = APP_CONST.API.DOCUMENT_HISTORY;
  let requestParam = `documentId=${documentid}`;
  if (lastModifiedOn)
    requestParam = `${requestParam}&lastmodifiedon=${lastModifiedOn}&documentVersionGuid=${documentversionguid}`;
  return API.get(`${contextPath}?${requestParam}`);
};

export const doGetDocumentVersionList = (id) => {
  const contextPath = APP_CONST.API.DOCUMENT_VERSION_LIST;
  return API.get(`${contextPath}?documentId=${id}`);
};

export const getSelectedDocumentDetail = (id) => {
  const contextPath = APP_CONST.API.DOCUMENT_DETAILS;
  return API.get(`${contextPath}?documentVersionId=${id}`);
};

export const doDocumentDelete = (payload) => {
  const { id, reason, lastModifiedOn } = payload;
  let documentDeletePath = `${APP_CONST.API.DELETE_DOCUMENT}?documentId=${id}&lastModifiedOn=${lastModifiedOn}`;
  if (reason) documentDeletePath = `${documentDeletePath}&comments=${reason}`;
  return API.delete(documentDeletePath);
};

export const aggridGetDocument = (payload) => {
  const contextPath = APP_CONST.API.AGGRIDGET_DOCUMENT;
  return API.post(contextPath, payload);
};

export const doGetDocumentMaster = () => {
  const contextPath = APP_CONST.API.DOCUMENT_DOCUMENTMASTER;
  return API.get(contextPath);
};

export const doGetDropZoneDocumentGuid = (filesCount) => {
  const contextPath = APP_CONST.API.DROPZONE_DOCUMENT_GUID;
  return API.get(`${contextPath}?numberOfGuid=${filesCount}`);
};

export const docApproveDoc = (data) => {
  const contextPath = APP_CONST.API.DOCUMENT_APPROVE;
  return API.put(contextPath, data);
};

export const docPublishDocDetails = (data) => {
  const contextPath = APP_CONST.API.DOCUMENT_PUBLISH;
  return API.put(contextPath, data);
};

export const docUnPublishDocDetails = (data) => {
  const contextPath = APP_CONST.API.DOCUMENT_UNPUBLISH;
  return API.put(contextPath, data);
};

export const doDocumentLock = (data) => {
  const contextPath = APP_CONST.API.DOCUMENT_LOCK;
  return API.put(contextPath, data);
};

export const doGetReviewActionDetail = (payload) => {
  const { documentid, documentversionguid } = payload;
  const contextPath = APP_CONST.API.DOCUMENT_GET_REVIEW;
  return API.get(
    `${contextPath}?documentId=${documentid}&documentVersionGuid=${documentversionguid}`
  );
};

export const doSaverevieweraction = (data) => {
  const contextPath = APP_CONST.API.DOCUMENT_SAVE_REVIEW;
  return API.post(contextPath, data);
};

export const docUpdateChanges = (data) => {
  const contextPath = APP_CONST.API.DOCUMENT_UPDATE;
  return API.put(contextPath, data);
};

export const addDocNote = (data) => {
  const contextPath = APP_CONST.API.ADD_NOTES;
  return API.post(contextPath, data);
};
export const getDocNote = (versionId, dropzoneId) => {
  const contextPath = APP_CONST.API.GET_NOTES;
  return API.get(`${contextPath}?documentVersionId=${versionId}&tmfdropzoneid=${dropzoneId}`);
};
export const resolveDocNote = (data) => {
  const contextPath = APP_CONST.API.RESOLVE_NOTE;
  return API.put(contextPath, data);
};

export const doFileScreening = (data) => {
  const contextPath = APP_CONST.API.FILE_SCREENING;
  return API.post(contextPath, data);
};

export const getMileStoneData = (id) => {
  const contextPath = APP_CONST.API.MILESTONES
  return API.get(`${contextPath}?milestoneId=${id}`);
};
export const getMileStoneArtifactCount = (id) => {
  const contextPath = APP_CONST.API.MILESTONE_ARTIFACTS;
  return API.get(`${contextPath}?milestoneId=${id}`);
};

export const addNewMileStone = (data) => {
  const contextPath = APP_CONST.API.ADD_EDIT_MILESTONE
  return API.post(contextPath, data);
};

export const doEditMileStone = (data) => {
  const contextPath = APP_CONST.API.ADD_EDIT_MILESTONE;
  return API.put(contextPath, data);
};
export const changeMileStoneSequence = (data) => {
  const contextPath = APP_CONST.API.MOVE_MILESTONE;
  return API.put(contextPath, data);
};
export const doDeleteMileStone = (data) => {
  const { id, lastModifiedOn } = data;
  const contextPath = APP_CONST.API.ADD_EDIT_MILESTONE;
  return API.delete(`${contextPath}?id=${id}&lastmodifiedon=${lastModifiedOn}`);
};

export const getDocumentContentDetails = (id, versionId) => {
  const contextPath = APP_CONST.API.DOCUMENT_CONTENT;
  return API.get(`${contextPath}?documentId=${id}&documentversionid=${versionId}`);
}

export const saveCustomizedColState = (data) => {
  const contextPath = APP_CONST.API.COLUMN_PREFERENCE;
  return API.put(contextPath, data);
};
export const getCustomizedColState = () => {
  const contextPath = APP_CONST.API.COLUMN_PREFERENCE;
  return API.get(contextPath);
};

export const getAdminsharingSettings = () => {
  const contextPath = APP_CONST.API.ADMIN_SHARING_SETTINGS;
  return API.get(contextPath);
}

export const getDocumentSharingMetricsByVersion = (id) => {
  const contextPath = APP_CONST.API.DOCUMENT_SHARING_METRICS;
  return API.get(`${contextPath}?documentid=${id}`);
}

export const getDocumentSharingUsers = (data) => {
  const contextPath = APP_CONST.API.DOCUMENT_SHARING_USERS;
  return API.get(`${contextPath}?documentid=${data.documentid}&isrequiredclinic=${data.isrequiredclinic}&isrequiredsubject=${data.isrequiredsubject}`);
};

export const getExistingSharedUserList = (id, forceData, date) => {
  const contextPath = APP_CONST.API.EXISTING_SHARED_USER_LIST;
  return API.get(`${contextPath}?documentid=${id}&isForceDataGet=${forceData}&lastModifiedOn=${date}`);
}

export const doGetSharedFileCount = (id) => {
  const contextPath = APP_CONST.API.SHARED_FILE_COUNT;
  return API.get(`${contextPath}?${id}`);
}

export const updateUserSharedListService = (data) => {
  const contextPath = APP_CONST.API.UPDATE_USER_SHARED_LIST;
  return API.put(contextPath, data);
}

export const getBindersDetails = (id) => {
  const contextPath = APP_CONST.API.GET_BINDER_DETAILS;
  return API.get(`${contextPath}?sharingbinderid=${id}`);
}

export const createBinderForSharing = (data) => {
  const contextPath = APP_CONST.API.CREATE_BINDER_SHARING;
  return API.post(contextPath, data);
};

export const getBindersHistory = (id) => {
  const contextPath = APP_CONST.API.BINDER_HISTORY;
  return API.get(`${contextPath}?sharingbinderid=${id}`);
}
export const reCallBinders = (data) => {
  return API.post(`document/updatesharingbinderrecall`, data);
}
export const downloadSharingDetails = (data) => {
  return API.post(`document/createsharingdetailszip`, data);
};
export const getDownloadSharingDetailsStatus = (data) => {
  return API.get(`document/getzipfilestatus/${data.sharingActionId}/${data.zipFileName}`);
};
export const downloadSignatureZipDetails = (data) => {
  return API.post(`document/createsignaturedocumentzip`, data);
};
export const downloadWithNotes = (data) => {
  return API.get(`document/getnotesdocumentsastoken?SharingBinderId=${data.sharingBinderId}&FileName=${data.fileName}&FriendlyFileName=${data.friendlyFileName}&isfrometmfbinder=${data.isfrometmfbinder}`)
}